import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchEmployerCandidateUnlockListExport } from "./employerCandidateUnlockListExportAPI";

const initialState = {
    data: [],
    loading: false,
    error: null,
    status: 'idle',
};

// ✅ Async thunk with no parameters
export const fetchEmployerCandidateUnlockListExportAsync = createAsyncThunk(
    "employerCandidateUnlockListExport/fetch",
    async (_, { rejectWithValue }) => {
        try {
            // console.log('Calling API with no params');

            const response = await fetchEmployerCandidateUnlockListExport();
            // console.log('API response in thunk:', response);

            if (response?.status === 'success' && response?.response) {
                return response.response;
            } else if (response?.data) {
                return response.data;
            } else if (Array.isArray(response)) {
                return response;
            } else {
                return response;
            }
        } catch (error) {
            // console.error('Thunk error:', error);
            return rejectWithValue(error.message || 'An error occurred while fetching data');
        }
    }
);

const employerCandidateUnlockListExportSlice = createSlice({
    name: "employerCandidateUnlockListExport",
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
        resetState: (state) => {
            state.data = [];
            state.loading = false;
            state.error = null;
            state.status = 'idle';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchEmployerCandidateUnlockListExportAsync.pending, (state) => {
                // console.log('Thunk pending');
                state.loading = true;
                state.error = null;
                state.status = 'loading';
            })
            .addCase(fetchEmployerCandidateUnlockListExportAsync.fulfilled, (state, action) => {
                // console.log('Thunk fulfilled with payload:', action.payload);
                state.loading = false;
                state.status = 'succeeded';
                state.data = Array.isArray(action.payload) ? action.payload : [];
                state.error = null;
            })
            .addCase(fetchEmployerCandidateUnlockListExportAsync.rejected, (state, action) => {
                // console.log('Thunk rejected with error:', action.payload);
                state.loading = false;
                state.status = 'failed';
                state.error = action.payload || 'Failed to fetch data';
                state.data = [];
            });
    }
});

// Export actions
export const { clearError, resetState } = employerCandidateUnlockListExportSlice.actions;

// Export reducer
export default employerCandidateUnlockListExportSlice.reducer;
